/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum EntityGroupDetailSortByEnum {
    CODE = 'code',
    NAME = 'name'
}
